import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { Avatar, Dialog, Typography, Button, IconButton } from "@mui/material";
import useSystem from "../../hooks/useSystem";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import ContactWidget from "components/Widgets/ContactsCall";
import moment from "moment";
import { useRcState } from "WebR/system/Provider";
import { bringExt, presenceExt } from "api/connect";
import { Close } from "@mui/icons-material";
// eslint-disable-next-line react-hooks/exhaustive-deps
import { getMemberInfoRequest } from "api/memberInformation";

const InCall = () => {
  const [memberInfoInCall, setMemberInfoInCall] = useState(null);
  const [showChildComponent, setShowChildComponent] = React.useState(false);
  const [, setInitials] = React.useState("UN");
  const [, setInitialsNum] = React.useState("");
  const [time, setTime] = React.useState("Ringing");
  const { callService, updateCallData } = useRcState();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const {
    data,
    endCall,
    hold,
    unhold,
    mute,
    unmute,
    startRecording,
    stopRecording,
    setCallData,
  } = useSystem();

  const calculateInitials = (name) => {
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");
    let initials = [...name.matchAll(rgx)] || [];
    return (
      (initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
    ).toUpperCase();
  };

  React.useEffect(() => {
    if (
      typeof data === "object" &&
      data.contact &&
      typeof data.contact === "string" &&
      data.contact.trim() !== ""
    ) {
      const initialsal = calculateInitials(data.contact);
      setInitials(initialsal);
      setInitialsNum(data.contact);
    } else {
      setInitialsNum(data.phoneNo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.contact, data.state]);

  React.useEffect(() => {
    const startTime = data?.session?.startTime;
    const interval = setInterval(() => {
      const currentTime = startTime
        ? Math.round((Date.now() - startTime) / 1000)
        : 0;
      setTime(moment.utc(currentTime * 1000).format("HH:mm:ss"));
    }, 1000);
    return () => clearInterval(interval); // Cleanup the interval on component unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.session?.startTime]);

  const handleButtonClick = () => {
    setShowChildComponent(true);
  };

  const initConference = () => {
    updateCallData({
      type: 2,
    });

    presenceExt()
      .then((response) => {
        startConferenceCall(
          response.data.session.voiceCallToken,
          response.data.session.id
        )
          .then((onConference) => {})
          .catch((error) => {
            console.error("Error in startConferenceCall:", error);
          });
      })
      .catch((error) => {
        console.error("Error in getPresenceActiveCalls:", error);
      });
  };

  const callendsidba = async () => {
    try {
      await setCallData({
        open: false,
      });
      endCall();

      return true;
    } catch (error) {
      console.error("Error in startConferenceCall", error.stack || error);
      throw error;
    }
  };

  const startConferenceCall = async (number, id) => {
    try {
      const session = callService.webPhone.userAgent.invite(number, {
        fromNumber: callService.user.username,
      });

      await setCallData({
        type: "conference",
        state: "in-call",
        phoneNo: "",
        contact: "conference",
        isUnknown: false,
        session,
        ConferanceCall: "",
      });

      session.on("accepted", async () => {
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });

        try {
          await bringExt({ status: "accepted", session_id: id });
        } catch (error) {
          console.error("Conference call failed", error.stack || error);
          throw error;
        }
      });

      return true;
    } catch (error) {
      console.error("Error in startConferenceCall", error.stack || error);
      throw error;
    }
  };

  useEffect(() => {
    fetchMemberInfo(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.phoneNo]);

  const fetchMemberInfo = async (data) => {
    try {
      const response = await getMemberInfoRequest({ phone_no: data.phoneNo });
      setMemberInfoInCall(response.data);
    } catch (error) {
      console.error("Failed to fetch member info:", error);
    }
  };

  const handleClose = async () => {
    await setCallData({
      open: false,
      popopen: true,
    });
  };

  return (
    <>
      {data.open !== undefined && (
        <Dialog
          open={data.open}
          aria-labelledby="customized-dialog-title"
          fullWidth={true}
          maxWidth="sm"
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <Close />
          </IconButton>
          <Grid container spacing={2} direction="row" alignItems="center">
            <Grid
              item
              xs={4}
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              {memberInfoInCall?.status === false ? (
                <Grid direction="column" alignItems="center">
                  <Avatar
                    sx={{
                      mt: 3,
                      bgcolor: "#0B557B",
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      border: "10px solid #D2E2EA",
                      boxShadow: "0 0 0px 10px #EAF8FF",
                    }}
                  >
                    {"UN"}
                  </Avatar>
                  <Grid sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}>
                    <Typography>Unknown User </Typography>
                  </Grid>
                  {memberInfoInCall?.contacts &&
                    memberInfoInCall?.contacts.map((item) => (
                      <Grid
                        key={item.id}
                        direction="column"
                        alignItems="center"
                      >
                        <Typography
                          sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              display: "inline",
                              mb: 2,
                            }}
                          >
                            {item?.first_name} {item?.last_name}
                          </Typography>
                        </Typography>
                      </Grid>
                    ))}
                </Grid>
              ) : (
                memberInfoInCall?.contacts &&
                memberInfoInCall?.contacts.map((item) => (
                  <Grid
                    key={item.id}
                    container
                    direction="column"
                    alignItems="center"
                  >
                    <Typography
                      sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", display: "inline", mb: 2 }}
                      >
                        <Avatar
                          sx={{
                            mt: 3,
                            bgcolor: "#0B557B",
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            border: "10px solid #D2E2EA",
                            boxShadow: "0 0 0px 10px #EAF8FF",
                          }}
                        >
                          {item?.first_name.charAt(0).toUpperCase() +
                            item?.last_name.charAt(0).toUpperCase()}
                        </Avatar>
                        <Grid
                          sx={{ mt: 2, fontSize: "10px", textAlign: "center" }}
                        >
                          <Typography>
                            {item?.first_name} {item?.last_name}{" "}
                          </Typography>
                        </Grid>
                      </Typography>
                    </Typography>
                  </Grid>
                ))
              )}
            </Grid>
            <Grid item xs={8} direction="column" justifyContent="center">
              <Box sx={{ flexDirection: "row", ml: 2 }}>
                <Typography
                  sx={{ fontSize: "26px", color: "#346077", mt: 4, ml: 2 }}
                >
                  Incoming Call
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#515151",
                    fontWeight: 600,
                    lineHeight: "normal",
                    ml: 2,
                  }}
                >
                  Duration:{" "}
                  <span
                    style={{
                      fontSize: "15px",
                      color: "#5B5B5B",
                      fontWeight: 400,
                      lineHeight: "normal",
                    }}
                  >
                    {time}
                  </span>
                </Typography>
                <List sx={{ display: "flex" }}>
                  <ListItem sx={{ display: "block", textAlign: "center" }}>
                    {data.muted ? (
                      <ListItemIcon
                        sx={{
                          width: "25px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#116089",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => unmute()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="14"
                          viewBox="0 0 12 14"
                          fill="none"
                        >
                          <path
                            d="M4.06046 8.06715L3.36636 8.76125C2.90497 8.22887 2.65152 7.54769 2.65271 6.8432V2.9328C2.65271 2.15497 2.9617 1.409 3.51171 0.858997C4.06172 0.30899 4.80769 0 5.58551 0C6.36334 0 7.10931 0.30899 7.65931 0.858997C8.20932 1.409 8.51831 2.15497 8.51831 2.9328V3.61028L7.54071 4.58787V2.9328C7.54071 2.41425 7.33472 1.91694 6.96805 1.55026C6.60138 1.18359 6.10406 0.9776 5.58551 0.9776C5.06696 0.9776 4.56965 1.18359 4.20298 1.55026C3.83631 1.91694 3.63031 2.41425 3.63031 2.9328V6.8432C3.63031 7.30658 3.79162 7.73281 4.06046 8.06715ZM4.85427 8.65664C5.15104 8.77632 5.47265 8.82133 5.79087 8.78772C6.1091 8.75411 6.41421 8.64291 6.67943 8.46387C6.94466 8.28484 7.16188 8.04344 7.31205 7.76087C7.46222 7.4783 7.54073 7.16319 7.54071 6.8432V5.9702L8.51831 4.9926V6.8432C8.51849 7.35762 8.38336 7.86304 8.12648 8.30873C7.8696 8.75443 7.50001 9.12471 7.0548 9.38243C6.60959 9.64015 6.10442 9.77623 5.59 9.77701C5.07558 9.7778 4.57 9.64327 4.124 9.38691L4.85427 8.65664ZM2.57451 10.9364L3.27936 10.2325C3.82383 10.5742 4.45389 10.7549 5.09671 10.7536H6.07431C6.98178 10.7536 7.85207 10.3931 8.49375 9.75143C9.13542 9.10976 9.49591 8.23946 9.49591 7.332V6.8432C9.49591 6.71356 9.54741 6.58923 9.63908 6.49756C9.73074 6.4059 9.85507 6.3544 9.98471 6.3544C10.1143 6.3544 10.2387 6.4059 10.3303 6.49756C10.422 6.58923 10.4735 6.71356 10.4735 6.8432V7.332C10.4735 8.49874 10.01 9.61769 9.18501 10.4427C8.36001 11.2677 7.24105 11.7312 6.07431 11.7312V12.7088H7.05191C7.18155 12.7088 7.30588 12.7603 7.39755 12.852C7.48921 12.9436 7.54071 13.068 7.54071 13.1976C7.54071 13.3272 7.48921 13.4516 7.39755 13.5432C7.30588 13.6349 7.18155 13.6864 7.05191 13.6864H4.11911C3.98948 13.6864 3.86515 13.6349 3.77348 13.5432C3.68181 13.4516 3.63031 13.3272 3.63031 13.1976C3.63031 13.068 3.68181 12.9436 3.77348 12.852C3.86515 12.7603 3.98948 12.7088 4.11911 12.7088H5.09671V11.7312C4.15822 11.7312 3.28815 11.4379 2.57451 10.9364ZM1.83935 10.2892C1.10316 9.48045 0.695892 8.42567 0.697515 7.332V6.8432C0.697515 6.71356 0.749013 6.58923 0.840681 6.49756C0.932349 6.4059 1.05668 6.3544 1.18631 6.3544C1.31595 6.3544 1.44028 6.4059 1.53195 6.49756C1.62362 6.58923 1.67511 6.71356 1.67511 6.8432V7.332C1.67511 8.20011 1.9987 8.99392 2.53149 9.5971L1.83935 10.2892Z"
                            fill="#fff"
                          />
                          <path
                            d="M0.830048 12.9076C0.738253 12.9971 0.614965 13.047 0.486755 13.0465C0.358545 13.0459 0.235679 12.995 0.144636 12.9048C0.0535931 12.8145 0.00166365 12.6921 3.9281e-05 12.5639C-0.00158509 12.4357 0.0472257 12.312 0.135952 12.2194L10.8895 1.3964C10.9813 1.3069 11.1046 1.25704 11.2328 1.25757C11.3611 1.25811 11.4839 1.309 11.575 1.39927C11.666 1.48954 11.7179 1.61197 11.7196 1.74018C11.7212 1.86838 11.6724 1.99208 11.5836 2.08463L0.830048 12.9076Z"
                            fill="#fff"
                          />
                        </svg>
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon
                        sx={{
                          width: "25px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#EAF8FF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => mute()}
                      >
                        <svg
                          width="12"
                          height="16"
                          viewBox="0 0 12 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.98586 3.05352C7.98586 1.91939 7.04758 1 5.89015 1C4.73272 1 3.79443 1.91939 3.79443 3.05352V7.16057C3.79443 8.29471 4.73272 9.2141 5.89015 9.2141C7.04758 9.2141 7.98586 8.29471 7.98586 7.16057V3.05352Z"
                            stroke="#116089"
                            strokeWidth="1.3"
                            fill="#fff"
                          />
                          <path
                            d="M1 6.47559V7.16009C1 8.43089 1.51519 9.64965 2.43225 10.5482C3.3493 11.4468 4.59309 11.9517 5.89 11.9517M5.89 11.9517C7.18691 11.9517 8.4307 11.4468 9.34775 10.5482C10.2648 9.64965 10.78 8.43089 10.78 7.16009V6.47559M5.89 11.9517V14.6897M5.89 14.6897H3.79429M5.89 14.6897H7.98571"
                            stroke="#116089"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill="#fff"
                          />
                        </svg>
                      </ListItemIcon>
                    )}
                    <ListItemText>
                      <Typography variant="body2" className="callOption-text">
                        Mute
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ display: "block", textAlign: "center" }}>
                    {data.recording ? (
                      <ListItemIcon
                        sx={{
                          width: "25px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#116089",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => stopRecording()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="8"
                          viewBox="0 0 18 8"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.87686 6.73684C7.50263 6.06594 7.87937 5.19857 7.9436 4.28089C8.00782 3.3632 7.75561 2.4513 7.22945 1.69883C6.70329 0.946357 5.93534 0.399309 5.05501 0.149859C4.17468 -0.0995908 3.23577 -0.0361942 2.39649 0.329367C1.5572 0.694928 0.868841 1.34031 0.447387 2.15677C0.0259337 2.97322 -0.10285 3.91085 0.0827364 4.81166C0.268322 5.71248 0.756933 6.52142 1.46624 7.10218C2.17555 7.68294 3.0622 8.00002 3.97679 8H14.0232C14.9378 8.00002 15.8244 7.68294 16.5338 7.10218C17.2431 6.52142 17.7317 5.71248 17.9173 4.81166C18.1028 3.91085 17.9741 2.97322 17.5526 2.15677C17.1312 1.34031 16.4428 0.694928 15.6035 0.329367C14.7642 -0.0361942 13.8253 -0.0995908 12.945 0.149859C12.0647 0.399309 11.2967 0.946357 10.7706 1.69883C10.2444 2.4513 9.99218 3.3632 10.0564 4.28089C10.1206 5.19857 10.4974 6.06594 11.1231 6.73684H6.87686ZM3.97679 1.26316C3.25517 1.26316 2.56309 1.5515 2.05283 2.06476C1.54256 2.57802 1.25589 3.27415 1.25589 4C1.25589 4.72586 1.54256 5.42198 2.05283 5.93524C2.56309 6.4485 3.25517 6.73684 3.97679 6.73684C4.69842 6.73684 5.39049 6.4485 5.90076 5.93524C6.41103 5.42198 6.6977 4.72586 6.6977 4C6.6977 3.27415 6.41103 2.57802 5.90076 2.06476C5.39049 1.5515 4.69842 1.26316 3.97679 1.26316ZM14.0232 6.73684C14.7448 6.73684 15.4369 6.4485 15.9472 5.93524C16.4574 5.42198 16.7441 4.72586 16.7441 4C16.7441 3.27415 16.4574 2.57802 15.9472 2.06476C15.4369 1.5515 14.7448 1.26316 14.0232 1.26316C13.3016 1.26316 12.6095 1.5515 12.0992 2.06476C11.589 2.57802 11.3023 3.27415 11.3023 4C11.3023 4.72586 11.589 5.42198 12.0992 5.93524C12.6095 6.4485 13.3016 6.73684 14.0232 6.73684Z"
                            fill="#fff"
                          />
                        </svg>
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon
                        sx={{
                          width: "25px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#EAF8FF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => startRecording()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="8"
                          viewBox="0 0 18 8"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.87686 6.73684C7.50263 6.06594 7.87937 5.19857 7.9436 4.28089C8.00782 3.3632 7.75561 2.4513 7.22945 1.69883C6.70329 0.946357 5.93534 0.399309 5.05501 0.149859C4.17468 -0.0995908 3.23577 -0.0361942 2.39649 0.329367C1.5572 0.694928 0.868841 1.34031 0.447387 2.15677C0.0259337 2.97322 -0.10285 3.91085 0.0827364 4.81166C0.268322 5.71248 0.756933 6.52142 1.46624 7.10218C2.17555 7.68294 3.0622 8.00002 3.97679 8H14.0232C14.9378 8.00002 15.8244 7.68294 16.5338 7.10218C17.2431 6.52142 17.7317 5.71248 17.9173 4.81166C18.1028 3.91085 17.9741 2.97322 17.5526 2.15677C17.1312 1.34031 16.4428 0.694928 15.6035 0.329367C14.7642 -0.0361942 13.8253 -0.0995908 12.945 0.149859C12.0647 0.399309 11.2967 0.946357 10.7706 1.69883C10.2444 2.4513 9.99218 3.3632 10.0564 4.28089C10.1206 5.19857 10.4974 6.06594 11.1231 6.73684H6.87686ZM3.97679 1.26316C3.25517 1.26316 2.56309 1.5515 2.05283 2.06476C1.54256 2.57802 1.25589 3.27415 1.25589 4C1.25589 4.72586 1.54256 5.42198 2.05283 5.93524C2.56309 6.4485 3.25517 6.73684 3.97679 6.73684C4.69842 6.73684 5.39049 6.4485 5.90076 5.93524C6.41103 5.42198 6.6977 4.72586 6.6977 4C6.6977 3.27415 6.41103 2.57802 5.90076 2.06476C5.39049 1.5515 4.69842 1.26316 3.97679 1.26316ZM14.0232 6.73684C14.7448 6.73684 15.4369 6.4485 15.9472 5.93524C16.4574 5.42198 16.7441 4.72586 16.7441 4C16.7441 3.27415 16.4574 2.57802 15.9472 2.06476C15.4369 1.5515 14.7448 1.26316 14.0232 1.26316C13.3016 1.26316 12.6095 1.5515 12.0992 2.06476C11.589 2.57802 11.3023 3.27415 11.3023 4C11.3023 4.72586 11.589 5.42198 12.0992 5.93524C12.6095 6.4485 13.3016 6.73684 14.0232 6.73684Z"
                            fill="#116089"
                          />
                        </svg>
                      </ListItemIcon>
                    )}
                    <ListItemText>
                      <Typography variant="body2" className="callOption-text">
                        Record
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ display: "block", textAlign: "center" }}>
                    {data.onHold ? (
                      <ListItemIcon
                        sx={{
                          width: "25px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#116089",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => unhold()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                        >
                          <path
                            d="M6.33293 3.1665C6.52683 3.16653 6.71399 3.23772 6.85889 3.36657C7.00379 3.49542 7.09636 3.67297 7.11905 3.86555L7.12459 3.95817V15.0415C7.12437 15.2433 7.04711 15.4374 6.90859 15.5841C6.77007 15.7308 6.58076 15.8191 6.37932 15.8309C6.17789 15.8428 5.97954 15.7772 5.82481 15.6477C5.67008 15.5182 5.57063 15.3345 5.5468 15.1341L5.54126 15.0415V3.95817C5.54126 3.74821 5.62467 3.54684 5.77313 3.39838C5.9216 3.24991 6.12296 3.1665 6.33293 3.1665ZM12.6663 3.1665C12.8602 3.16653 13.0473 3.23772 13.1922 3.36657C13.3371 3.49542 13.4297 3.67297 13.4524 3.86555L13.4579 3.95817V15.0415C13.4577 15.2433 13.3804 15.4374 13.2419 15.5841C13.1034 15.7308 12.9141 15.8191 12.7127 15.8309C12.5112 15.8428 12.3129 15.7772 12.1581 15.6477C12.0034 15.5182 11.904 15.3345 11.8801 15.1341L11.8746 15.0415V3.95817C11.8746 3.74821 11.958 3.54684 12.1065 3.39838C12.2549 3.24991 12.4563 3.1665 12.6663 3.1665Z"
                            fill="#fff"
                          />
                        </svg>
                      </ListItemIcon>
                    ) : (
                      <ListItemIcon
                        sx={{
                          width: "25px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "#EAF8FF",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => hold()}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                        >
                          <path
                            d="M6.33293 3.1665C6.52683 3.16653 6.71399 3.23772 6.85889 3.36657C7.00379 3.49542 7.09636 3.67297 7.11905 3.86555L7.12459 3.95817V15.0415C7.12437 15.2433 7.04711 15.4374 6.90859 15.5841C6.77007 15.7308 6.58076 15.8191 6.37932 15.8309C6.17789 15.8428 5.97954 15.7772 5.82481 15.6477C5.67008 15.5182 5.57063 15.3345 5.5468 15.1341L5.54126 15.0415V3.95817C5.54126 3.74821 5.62467 3.54684 5.77313 3.39838C5.9216 3.24991 6.12296 3.1665 6.33293 3.1665ZM12.6663 3.1665C12.8602 3.16653 13.0473 3.23772 13.1922 3.36657C13.3371 3.49542 13.4297 3.67297 13.4524 3.86555L13.4579 3.95817V15.0415C13.4577 15.2433 13.3804 15.4374 13.2419 15.5841C13.1034 15.7308 12.9141 15.8191 12.7127 15.8309C12.5112 15.8428 12.3129 15.7772 12.1581 15.6477C12.0034 15.5182 11.904 15.3345 11.8801 15.1341L11.8746 15.0415V3.95817C11.8746 3.74821 11.958 3.54684 12.1065 3.39838C12.2549 3.24991 12.4563 3.1665 12.6663 3.1665Z"
                            fill="#116089"
                          />
                        </svg>
                      </ListItemIcon>
                    )}
                    <ListItemText>
                      <Typography variant="body2" className="callOption-text">
                        Hold
                      </Typography>
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ display: "block", textAlign: "center" }}>
                    <ListItemIcon
                      sx={{
                        width: "25px",
                        height: "50px",
                        borderRadius: "50%",
                        backgroundColor: "#EAF8FF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <PersonAddAltIcon onClick={handleButtonClick} />
                    </ListItemIcon>
                    <ListItemText>
                      <Typography variant="body2" className="callOption-text">
                        Add
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </List>
                <Button
                  variant="contained"
                  size="medium"
                  sx={{ mb: 3, borderRadius: 22, bgcolor: "#F44336" }}
                  onClick={callendsidba}
                >
                  <Box component="span" sx={{ mr: 2 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.736 1.22692C5.722 -0.206077 3.694 -0.448077 2.468 0.842923L0.898001 2.49492C0.362001 3.05992 -0.0449987 3.84292 0.00400125 4.75692C0.104001 6.60692 0.888001 10.3909 5.022 14.7419C9.451 19.4059 13.676 19.6399 15.5 19.4599C16.247 19.3869 16.852 18.9879 17.295 18.5209L18.715 17.0259C20.02 15.6519 19.64 13.3529 18.008 12.4129L16.097 11.3129C14.998 10.6809 13.637 10.8619 12.762 11.7819L12.354 12.2119C12.258 12.2383 12.1571 12.2407 12.06 12.2189C11.658 12.1529 10.79 11.7979 9.357 10.2899C7.929 8.78692 7.577 7.86092 7.511 7.40592C7.479 7.18592 7.511 7.06992 7.524 7.03392L7.527 7.02792L7.771 6.76992C8.739 5.75192 8.807 4.15792 7.997 3.00992L6.736 1.22692ZM3.556 1.87592C4.078 1.32592 4.999 1.36892 5.511 2.09292L6.771 3.87692C7.194 4.47392 7.129 5.26792 6.684 5.73692L6.397 6.03892L6.929 6.54392C6.7537 6.37377 6.57601 6.20609 6.396 6.04092L6.394 6.04192L6.391 6.04492L6.385 6.05192L6.372 6.06692C6.33341 6.11054 6.29862 6.15738 6.268 6.20692C6.216 6.28792 6.159 6.39692 6.111 6.53092C6.013 6.80592 5.961 7.16892 6.027 7.62292C6.157 8.51592 6.742 9.71492 8.269 11.3229C9.792 12.9269 10.942 13.5569 11.819 13.6989C12.27 13.7719 12.635 13.7139 12.911 13.6049C13.064 13.5446 13.2062 13.4598 13.332 13.3539L13.368 13.3209L13.382 13.3069L13.389 13.3009L13.392 13.2969L13.393 13.2959C13.393 13.2959 13.395 13.2939 12.867 12.7939L13.395 13.2939L13.85 12.8149C14.235 12.4089 14.836 12.3179 15.349 12.6129L17.259 13.7129C18.08 14.1849 18.241 15.3469 17.628 15.9929L16.208 17.4879C15.928 17.7819 15.636 17.9399 15.353 17.9679C13.918 18.1089 10.173 17.9879 6.109 13.7089C2.233 9.62892 1.583 6.18592 1.502 4.67692C1.48 4.27692 1.654 3.87692 1.986 3.52792L3.556 1.87592Z"
                        fill="white"
                      />
                      <path
                        d="M14.28 1.22082C14.1378 1.08834 13.9497 1.01622 13.7554 1.01965C13.5611 1.02308 13.3758 1.10179 13.2383 1.2392C13.1009 1.37661 13.0222 1.562 13.0188 1.7563C13.0154 1.9506 13.0875 2.13865 13.22 2.28082L14.69 3.75082L13.22 5.22082C13.1463 5.28948 13.0872 5.37229 13.0462 5.46428C13.0052 5.55628 12.9832 5.6556 12.9814 5.7563C12.9796 5.857 12.9981 5.95703 13.0358 6.05042C13.0736 6.14381 13.1297 6.22864 13.2009 6.29986C13.2722 6.37108 13.357 6.42722 13.4504 6.46495C13.5438 6.50267 13.6438 6.52119 13.7445 6.51941C13.8452 6.51764 13.9445 6.4956 14.0365 6.4546C14.1285 6.41361 14.2113 6.35451 14.28 6.28082L15.75 4.81082L17.22 6.28082C17.2886 6.35451 17.3714 6.41361 17.4634 6.4546C17.5554 6.4956 17.6547 6.51764 17.7554 6.51941C17.8562 6.52119 17.9562 6.50267 18.0496 6.46495C18.143 6.42722 18.2278 6.37108 18.299 6.29986C18.3702 6.22864 18.4264 6.14381 18.4641 6.05042C18.5018 5.95703 18.5203 5.857 18.5186 5.7563C18.5168 5.6556 18.4947 5.55628 18.4538 5.46428C18.4128 5.37229 18.3537 5.28948 18.28 5.22082L16.81 3.75082L18.28 2.28082C18.4125 2.13865 18.4846 1.9506 18.4811 1.7563C18.4777 1.562 18.399 1.37661 18.2616 1.2392C18.1242 1.10179 17.9388 1.02308 17.7445 1.01965C17.5502 1.01622 17.3621 1.08834 17.22 1.22082L15.75 2.69082L14.28 1.22082Z"
                        fill="white"
                      />
                    </svg>
                  </Box>
                  Call End
                </Button>
                {data.ConferanceCall && (
                  //<Button variant="contained" size="medium" sx={{ ml: 1 }} onClick={initConference}>Start Conference</Button>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{ mb: 3, ml: 2, borderRadius: 22, bgcolor: "#757ce8" }}
                    onClick={initConference}
                  >
                    <Box component="span" sx={{ mr: 2 }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M13 5C13.5304 5 14.0391 5.21071 14.4142 5.58579C14.7893 5.96086 15 6.46957 15 7M13 1C14.5913 1 16.1174 1.63214 17.2426 2.75736C18.3679 3.88258 19 5.4087 19 7M3 2H7L9 7L6.5 8.5C7.57096 10.6715 9.32847 12.429 11.5 13.5L13 11L18 13V17C18 17.5304 17.7893 18.0391 17.4142 18.4142C17.0391 18.7893 16.5304 19 16 19C12.0993 18.763 8.42015 17.1065 5.65683 14.3432C2.8935 11.5798 1.23705 7.90074 1 4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2Z"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Box>
                    Start Conference
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Dialog>
      )}
      {showChildComponent && (
        <ContactWidget
          setShowChildComponent={setShowChildComponent}
          showChildComponent={showChildComponent}
        />
      )}
    </>
  );
};

export default React.memo(InCall);
